var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"MASONRY-COLUMNS-CELL",attrs:{"data-masonry-columns-cell":""}},[_c('div',{class:{ 'BORDER': _vm.bordered },attrs:{"data-masonry-columns-cell-content":""}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }